import { UIButton } from 'src/components/ui/Button'
import { UIDialog } from 'src/components/ui/Modal'
import Text from 'src/components/ui/Text'
import { openMembershipMoreCreditsModal } from './MembershipMoreCreditsModal'

interface MembershipFeatureDialogProps {
  dialogTitle?: React.ReactNode
  dialogBody: React.ReactNode

  trackingLocation: string
  close: () => void
}

export function openMembershipFeatureDialog(
  props: Omit<MembershipFeatureDialogProps, 'close'>,
) {
  UIDialog.create({
    dismissable: true,
    className: 'max-w-sm',
    heading: props.dialogTitle ?? (
      <Text i18nKey="membership:membership-only-feature-dialog.title" />
    ),
    content: props.dialogBody,
    footer: ({ close }) => (
      <>
        <UIButton
          size="large"
          className="w-full text-white bg-gradient-purple-pink border-none"
          onPress={() => {
            close()
            openMembershipMoreCreditsModal({
              defaultMode: 'plans',
              trackingLocation: props.trackingLocation,
            })
          }}
        >
          <Text i18nKey="membership:membership-only-feature-dialog.action.view-plans" />
        </UIButton>
        <UIButton className="w-full border-0" onPress={() => close()}>
          <Text i18nKey="artwork:feedback.early-access-dialog.action.may-be-later" />
        </UIButton>
      </>
    ),
    modalLayerProps: {
      // Ensure this dialog stays above any MUI dialogs
      className: 'z-[1400]',
    },
  })
}
